













import Page from '@/Page.vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import CloudFiles from '@/libs/cloud/components/CloudFiles.vue';
import { authStore } from '@/libs/auth/+store/store';
import { AccountTypeEnum, TenantUserModel } from '@/libs/Api';
import { AuthGetter } from '@/libs/auth/models/auth-state';

@Component({
    components: {
        CloudFiles
    }
})
export default class Files extends Page {

    @Prop() tenantId!: string;
    @Prop() partyId!: string;
    
    showFileComponent = true;
    
    mounted () {
        const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
        if (tenantUser.accountType == AccountTypeEnum.Volunteer) {
            this.$router.replace({
                name: "PartyGeneral",
                params: {
                    tenantId: this.$router.currentRoute.params.tenantId,
                    partyId: this.$router.currentRoute.params.partyId,
                }
            })
        }
    }
    
    restart() {
        this.showFileComponent = false;
        this.$nextTick(() => {
            this.showFileComponent = true;
        })
    }
    
}
